import React from 'react'; 
import { PropTypes } from 'prop-types';

import WordpressPage from '../components/WordpressPage';


/**
 * A factory function to produce a Next.js page for rendering a Wordpress template
 * Saves repetition of this component shape.
 * @param {object} args
 * @param {object} args.blockMap
 * @param {object} args.overrides
 * @returns {function}
 */
function createStaticWordpressPage({ blockMap }) {
    if (blockMap == null) {
        throw new RangeError('a blockMap must be supplied');
    }

    function Component({ blocks, ...otherProps }) {
        return (
            <WordpressPage
                blockMap={blockMap}
                blocks={blocks}
                {...otherProps}
            />
        );
    }

    Component.propTypes = {
        blocks: PropTypes.array,
    };

    return Component;
}

export default createStaticWordpressPage;
